import { createAction } from 'redux-actions';

export const createNotification = createAction(
    'CREATE_NOTIFICATION', 
    async value => await value
);